export default __webpack_public_path__ + "static/media/desembaraco.708ef98a.svg";